/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DetailedSessionStatsDto } from '../../models/detailed-session-stats-dto';

export interface PosSessionsControllerGetDetailedStats$Params {
  id: string;
}

export function posSessionsControllerGetDetailedStats(http: HttpClient, rootUrl: string, params: PosSessionsControllerGetDetailedStats$Params, context?: HttpContext): Observable<StrictHttpResponse<DetailedSessionStatsDto>> {
  const rb = new RequestBuilder(rootUrl, posSessionsControllerGetDetailedStats.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DetailedSessionStatsDto>;
    })
  );
}

posSessionsControllerGetDetailedStats.PATH = '/pos/sessions/{id}/stats/detailed';
